import { render, staticRenderFns } from "./pictos-picker.vue?vue&type=template&id=6d616f5e"
import script from "./pictos-picker.vue?vue&type=script&lang=js"
export * from "./pictos-picker.vue?vue&type=script&lang=js"
import style0 from "./pictos-picker.vue?vue&type=style&index=0&id=6d616f5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports